import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { login, logout } from 'src/api/users';
import {
  clearAllLS,
  getItem,
  getToken,
  removeToken,
  setItem,
  setToken,
  setItemToSession,
} from 'src/utils/localStorage';
import {authService} from "../../utils/oauth/AuthService";

export interface AuthState {
  token: string;
  status: 'idle' | 'loading' | 'ready';
}

const initialState: AuthState = {
  token: '',
  status: 'idle',
};

export const userLogin = createAsyncThunk(
  'auth/login',
  async (userInfo: {
    username?: string;
    password?: string;
    rememberMe?: boolean;
  }, { rejectWithValue }) => {
    let loginData: any;
    if (userInfo.username && userInfo.password) {
      loginData = {
        username: userInfo.username,
        password: userInfo.password,
      };
    } else {
      return rejectWithValue({ message: 'Invalid login credentials' });
    }

    try {
      const { data } = await login(loginData);
      const token = data.data?.accessToken;
      const refreshToken = data.data?.refreshToken;
      const rememberMe = userInfo.rememberMe ?? true;
      
      setToken(token, rememberMe);
      if (refreshToken) {
        if (rememberMe) {
          setItem('mbf_sso_refresh_token', refreshToken);
        } else {
          setItemToSession('mbf_sso_refresh_token', refreshToken);
        }
      }
      return token;
    } catch (error: any) {
      return rejectWithValue({
        message: error?.response?.data?.message || error?.message || 'Đăng nhập thất bại',
        response: error?.response,
        originalError: error,
      });
    }
  },
);

export const userLogout = createAsyncThunk(
  'auth/logout',
  async () => {
    const firebaseToken = encodeURIComponent(
      getItem('recruit_firebase_token') ?? '',
    );
    const _logout = () => {
      removeToken();
      localStorage.removeItem('mbf_sso_sessionId');
      clearAllLS();

      authService.startLogin(window.location.pathname);
    };


    // cmt logic: logout quay về trang login nội bộ, redirect sang SSO
    // const _logout = () => {
    //   removeToken();
    //   localStorage.removeItem('mbf_sso_id');
    //   localStorage.removeItem('mbf_sso_sessionId');
    //   clearAllLS();
    //   const clientId = encodeURIComponent(
    //     constants.SSO_CLIENT_ID,
    //   );
    //   const redirectUri = encodeURIComponent(
    //     constants.SSO_LOGOUT_CALLBACK,
    //   );
    //   const url = `${constants.SSO_URL_LOGOUT}?client_id=${clientId}&redirect_uri=${redirectUri}&userId=${userId}&sessionId=${sessionId}`;
    //   setTimeout(() => {
    //     if (userId && sessionId) window.location.href = url;
    //     else redirectToSSOPage();
    //   }, 500);
    // };
    if (firebaseToken) {
      logout({
        // Backend /api/auth/logout expects field "refreshToken"
        refreshToken: firebaseToken,
      }).then(
        res => {
          _logout();
        },
        error => {
          _logout();
        },
      );
    } else {
      _logout();
    }
  },
);

export const authenSlice = createSlice({
  name: 'authen',
  initialState,
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: builder => {
    builder.addCase(
      userLogin.fulfilled,
      (state, action: any) => {
        state.token = action.payload;
        state.status = 'ready';
      },
    );
  },
});

export const selectAuthen = (state: RootState) =>
  state.authen;

export default authenSlice.reducer;
